import React from 'react';
import PropTypes from 'prop-types';

import AccessButton from '../common/AccessButton';

const propTypes = {
    onClick: PropTypes.func.isRequired
};

const defaultProps = {};

function NewProjectTile({ onClick }) {
        return (
            <div className="tile project-tile new-tile">
                <h3 className="tile-title">Start</h3>
                <div className="tile-actions--bottom">
                    <AccessButton
                    onClick={onClick}
                    iconPath={GlobalConfig.StaticUrl + '/img/Add_med.svg'}
                    iconStyle={{width:'35px'}}
                    text="New Project"
                    />
                </div>
            </div>
        );
}

NewProjectTile.propTypes = propTypes;
NewProjectTile.defaultProps = defaultProps;

export default NewProjectTile;
